import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateSaleService } from '../create-sale';
import { map, takeUntil } from 'rxjs/operators';
import { UserService } from '@web-frontend/shared/services';
import { Router } from '@angular/router';
import { IDeal } from '@tacliatech/types';
import { Subject } from 'rxjs';

@Component({
  selector: 'charge-deal-modal',
  templateUrl: './charge-deal-modal.component.html',
  styleUrls: ['./charge-deal-modal.component.scss'],
})
export class ChargeDealModalComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ChargeDealModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deal: IDeal },
    private createSaleService: CreateSaleService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exit(): void {
    this.dialogRef.close();
  }

  onInvoice(): void {
    this.exit();
    this.router.navigate(['/admin/documents/create/bill'], {
      queryParams: { fromDealId: this.data.deal._id },
    });
  }

  onSimplified(): void {
    this.exit();
    const isCountryValid = this.userService.validateCountryES();

    if (isCountryValid) {
      this.router.navigate(['/admin/documents/create/simplified'], {
        queryParams: { fromDealId: this.data.deal._id },
      });
      return;
    }

    this.createSaleService
      .open({
        position: { right: '0px' },
        data: {
          mode: 'ADD',
          deal: this.data.deal,
        },
      })
      .pipe(
        map((res) => !res),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
